import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();
const Header = () => {
    let history = useHistory();
    const logout =()=>{
        history.push("/user/login");
    };
    const cart =()=>{
        history.push(`/user/cart`);
    };
    const order =()=>{
      history.push(`/user/order`);
    };
      const nav = {
        background: "#222",
        width: "100%"
      };
      
      const li = {
        listStyleType: "none"
      };
      
      const a = {
        float: "right",
        margin: "10px 30px 10px 0px",
        padding: "5px",
        display: "inline",
        textDecoration: "none",
        color: "white",
        borderRadius: "4px"
      };
      const orderbutton = {
        border: "1px solid #3366ff",
        color: "#3366ff",
        padding: "7px 10px",
        width: "80px",
        marginTop: "15px",
        transition: "0.4s",
        marginLeft: "20px"
      };
      const cartbutton = {
        border: "1px solid #fcad35",
        color: "#fcad35",
        padding: "7px 10px",
        width: "80px",
        marginTop: "15px",
        transition: "0.4s",
        marginLeft: "20px"
      };
      const logoutbutton = {
        border: "1px solid #df2933",
        color: "#df2933",
        padding: "7px 15px",
        width: "90px",
        transition: "0.4s",
        marginTop: "15px",
        marginLeft: "20px"
      };
      const input = {
        marginTop: "15px",
        paddingRight: "20px",
        marginRight: "30px"
      };
      const searchbutton = {
        marginTop: "15px",
        marginLeft: "20px"
      };
    const searchs =()=>{
        toast.warn("In this preview we are searching for cake")
        history.push(`/shops/search`);
    };    
    return(        
        <nav className="navbar navbar-expand-lg navbar-dark teal mb-4" style={nav}>
            <a className="navbar-brand" href="/CloudCart-Preview/#/Home"><img src={process.env.PUBLIC_URL + "/images/logo_new.png"} alt="Cloudcart" height="50px" width="200px" style={{marginTop:"5px"}} className="logo"/>
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item dropdown">
                    </li>
                </ul>
                <form className="form">
                    <input id="search"  className="form-control search" type="text" placeholder="cake" aria-label="Search" size="90" style={input}/>
                    </form>
                    <button
                        className="btn btn-outline-success"
                        type="button"
                        style={searchbutton}
                        onClick={searchs}>   
                        Search
                    </button>
                    <button
                    type="button"
                    className="btn btn-outline-dark"
                    style={orderbutton}
                >
                    <i 
                        className="fas fa-shopping-bag"
                        id="order-logo"
                        data-toggle="modal"
                        data-target="#oreder"
                        onClick={order}>
                    </i>
              </button>
                    <button
                        type="button"
                        className="btn btn-outline-dark"
                        style={cartbutton}
                    >
                        <i 
                            className="fas fa-shopping-cart"
                            id="cart-logo"
                            data-toggle="modal"
                            data-target="#cart"
                            onClick={cart}>
                        </i>
                </button>
                <button type="button" className="btn btn-outline-dark" style={logoutbutton} onClick={logout}>Logout</button>
            </div>
        </nav>
    );
};

export default Header;